export default function buildFingerprintEditorPresentationReducer(actionTypes) {
    const {
        FINGERPRINT_REMOVE_ITEM,
        FINGERPRINT_PREVIEW_REQUEST,
        FINGERPRINT_PREVIEW_RESPONSE,
        FINGERPRINT_PREVIEW_ERROR_RESPONSE,
    } = actionTypes
    return (state, action) => {
        const { type, data } = action
        switch (type) {
            case FINGERPRINT_PREVIEW_REQUEST:
                return {
                    ...state,
                    isFetchingFingerprintPreview: true,
                }
            case FINGERPRINT_PREVIEW_RESPONSE: {
                const updateModel = state.updateModel.set("fp", data)
                return {
                    ...state,
                    updateModel,
                    isFetchingFingerprintPreview: false,
                    fingerprintPreview: data,
                }
            }
            case FINGERPRINT_PREVIEW_ERROR_RESPONSE:
                return {
                    ...state,
                    isFetchingFingerprintPreview: false,
                    fingerprintPreview: null,
                }
            case FINGERPRINT_REMOVE_ITEM: {
                const fingerprintRemovedConcepts = (
                    state.fingerprintRemovedConcepts || []
                ).concat([data])
                const updateModel = state.updateModel.set(
                    "fp_removed_concepts",
                    fingerprintRemovedConcepts
                )
                return {
                    ...state,
                    updateModel,
                    fingerprintRemovedConcepts,
                }
            }
            default:
                return state
        }
    }
}
